'use client';

import { useEffect, useState } from 'react';

import { useApolloClient, useQuery } from '@apollo/client/react';
import type { GetStaticPaths, GetStaticProps } from 'next';
import { useRouter } from 'next/router';
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations';

import { WidgetsApp } from '@/components';
import { Types } from '@scorenco/core';

import { PlayersWidget } from '../../../components/Widgets';
import { resolveTeamId } from '../../../utils/teamIdResolver';
import { GetTeamMembersDocument } from '../../_internal/Widget.query.generated';

const Players = () => {
  const router = useRouter();
  const client = useApolloClient();
  const [resolvedTeamId, setResolvedTeamId] = useState<number>();

  // Pour les widgets MonSiteClub avec l'ancien ID
  useEffect(() => {
    if (router.query.teamId) {
      resolveTeamId(router.query.teamId, client)
        .then(setResolvedTeamId)
        .catch(console.error);
    }
  }, [router.query.teamId, client]);

  const getTeamMembers = useQuery(GetTeamMembersDocument, {
    variables: {
      teamId: resolvedTeamId!,
      cacheTTL: router.query.noCache ? 0 : undefined,
    },
    skip: !resolvedTeamId,
    context: {
      role: 'anonymous',
    },
  });

  const members =
    getTeamMembers.data?.teams_team_detail_by_team_id?.[0]?.team_in_season
      ?.members;

  return (
    <WidgetsApp
      widget={{
        __typename: 'widgets_widget',
        id: 0,
        settings: getTeamMembers.data?.widgets_club_settings?.[0] as
          | Types.Widgets_Club_Settings
          | undefined,
      }}
      noAds
    >
      <PlayersWidget members={members} />
    </WidgetsApp>
  );
};

export const getStaticPaths: GetStaticPaths = () => ({
  paths: [],
  fallback: 'blocking',
});

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale ?? 'fr', [
      'snc-components',
      'snc-core',
      'common',
    ])),
  },
});

export default Players;
